module.exports = __webpack_public_path__ + "static/media/catering_image1.7d15d14b.png";